module.exports = __webpack_public_path__ + "static/img/deportes_04.f9a44027.jpeg";